import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconUser$1 = /*@__PURE__*/ proxyCustomElement(class WppIconUser extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-user", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M7.20825 5.83335C7.20825 4.29156 8.45812 3.04169 9.99992 3.04169C11.5417 3.04169 12.7916 4.29156 12.7916 5.83335C12.7916 7.37515 11.5417 8.62502 9.99992 8.62502C8.45812 8.62502 7.20825 7.37515 7.20825 5.83335ZM9.99992 1.54169C7.6297 1.54169 5.70825 3.46313 5.70825 5.83335C5.70825 8.20358 7.6297 10.125 9.99992 10.125C12.3701 10.125 14.2916 8.20358 14.2916 5.83335C14.2916 3.46313 12.3701 1.54169 9.99992 1.54169ZM4.70825 13.3246C4.70825 13.1684 4.83497 13.0417 4.99117 13.0417H15.0091C15.1601 13.0417 15.2835 13.1601 15.2916 13.3091V13.9584C15.2916 14.848 14.7724 15.5728 13.7913 16.1142C12.7988 16.6617 11.4221 16.9584 9.99992 16.9584C8.57777 16.9584 7.20105 16.6617 6.20858 16.1142C5.22741 15.5728 4.70825 14.848 4.70825 13.9584V13.3246ZM16.792 14.7084H16.7158C16.4611 15.9315 15.5912 16.8342 14.5159 17.4275C13.2427 18.13 11.5986 18.4584 9.99992 18.4584C8.40123 18.4584 6.75712 18.13 5.48396 17.4275C4.19951 16.7189 3.20825 15.5687 3.20825 13.9584V13.3246C3.20825 12.34 4.00654 11.5417 4.99117 11.5417H15.0091C15.9937 11.5417 16.792 12.34 16.792 13.3246V14.7084Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-user-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-user", "wpp-icon-user-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-user-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-user-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconUser$1);
      }
      break;
  } });
}

const WppIconUser = WppIconUser$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconUser, defineCustomElement };
